import * as requestFromServer from "./superAdminSubscriptionsApis";
import Actions from "../../actions";;

// subscription -> get subscription api
export const getSuperAdminSubscriptionAction = (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getSuperAdminSubscription(dataToBeSent);
    if (response) {
      setLoading(false);
      dispatch(Actions.createAction(Actions.GET_SUPER_ADMIN_SUBSCRIPTION_LIST, {superAdminSubscription:response}))
      return response;
    } else {
      setLoading(false)
      return null;
    }
};